'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '__THEMING__';


//////////////////
// WEBPACK FOOTER
// ./~/theming/dist/cjs/channel.js
// module id = 83
// module chunks = 168707334958949